export default "__VITE_ASSET__BcGrYK6Y__"